import React from 'react';
import { Zap, ArrowRight, Play } from 'lucide-react';

const HeroSection = ({ onStartListing, onQuickList }) => {
  return (
    <section className="relative py-20 md:py-28 px-4" id="hero">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6" style={{
            background: 'rgba(0, 212, 255, 0.1)',
            border: '1px solid rgba(0, 212, 255, 0.3)'
          }}>
            <Zap size={14} color="#00D4FF" />
            <span className="text-xs font-semibold" style={{ color: '#00D4FF' }}>AI-Powered Listing Platform</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            <span style={{ color: '#E8F4FD' }}>Create Professional</span>
            <br />
            <span style={{
              background: 'linear-gradient(135deg, #00D4FF, #7B2FFF)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>Listings in Minutes</span>
          </h1>

          <p className="text-lg md:text-xl mb-10 max-w-2xl mx-auto leading-relaxed" style={{ color: '#6B9EC4' }}>
            AI-powered listing descriptions, automated market pricing analysis, and professional photo enhancement — everything agents need to close deals faster.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={onStartListing}
              className="flex items-center gap-2 px-8 py-4 rounded-xl text-base font-semibold transition-all w-full sm:w-auto justify-center"
              style={{
                background: 'linear-gradient(135deg, #00D4FF, #7B2FFF)',
                color: '#fff',
                boxShadow: '0 0 30px rgba(0, 212, 255, 0.4)'
              }}
            >
              Start Listing
              <ArrowRight size={18} />
            </button>
            <button
              onClick={onQuickList}
              className="flex items-center gap-2 px-8 py-4 rounded-xl text-base font-semibold transition-all w-full sm:w-auto justify-center"
              style={{
                background: 'rgba(0, 212, 255, 0.1)',
                color: '#00D4FF',
                border: '1px solid rgba(0, 212, 255, 0.3)'
              }}
            >
              <Play size={16} />
              Quick List
            </button>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-8 mt-14">
            {[
              { value: '12,000+', label: 'Active Listings' },
              { value: '3.2x', label: 'Faster to Publish' },
              { value: '94%', label: 'Agent Satisfaction' },
              { value: '48hrs', label: 'Avg. Time to First Lead' },
            ]?.map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-2xl font-bold" style={{ color: '#00D4FF' }}>{stat?.value}</div>
                <div className="text-xs mt-1" style={{ color: '#4A7A9B' }}>{stat?.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
